// Legacy boss behaviors — boss simulation remains in boss.ts.

import { registerBehavior } from './registry';
import { BossControl } from '../boss';

for (let i = 0; i < 4; i++) {
  registerBehavior({
    id: `meritous:legacy-boss-${i}`,
    onTick() {
      // BossControl() runs from dungeon-update when boss_fight_mode is active.
    },
  });
  registerBehavior({
    id: `meritous:legacy-boss-${i}-phase-2`,
    onTick() {},
  });
}

export function tickLegacyBoss(): void {
  BossControl();
}
